<app-page-body
  [class.d-none]="isShowNumbersAggregatorList || isVisibleHelpPage"
>
  <!-- header -->
  <app-page-header
    [title]="'pages.numbersAggregator.title'"
    [loading]="loading"
    (onBack)="onClose()"
    (onRefresh)="onReset()"
    [showBackBtn]="false"
    [showRefreshBtn]="false"
    [showAddBtn]="false"
    [showAuditBtn]="false"
    (onShowHelp)="onShowHelpPage()"
  >
  </app-page-header>

  <!-- content -->
  <div class="app-page-content">
    <div class="row">
      <div class="md:tw-w-2/3 offset-md-2">
        <form [formGroup]="form" autocomplete="off">
          <fieldset>
            <mobile-numbers-widget
              [title]="'common.numbers' | translate"
              [maxMobileNumbers]="10000"
              uniqId="numbers"
              [correctRows]="10"
              [wrongRows]="10"
              responsiveClass="md:tw-w-1/2"
              [form]="form"
              groupName="numbers"
              controlName="mobileNumbers"
              (mobileNumbers)="mobileNumbers = $event"
            >
            </mobile-numbers-widget>
          </fieldset>

          <!-- form btns-->
          <section class="">
            <div class="tw-flex tw-justify-end tw-mt-4">
              <div class="tw-flex tw-justify-end tw-h-[70%] tw-w-full">
                <!-- submit btn for inquire mobile aggregators-->
                <button
                  type="button"
                  (click)="onInquiryMobileAggregators()"
                  mat-ripple
                  class="btn tw-w-full tw-mr-[5px] ltr:tw-ml-[5px] tw-mb-1 tw-max-w-[250px]"
                  [themeColor]="'btn-gradient'"
                >
                  <ng-container *ngIf="!loading">
                    <ng-container>
                      <span class="submit-button-text-color">
                        {{ "common.aggregatorInquiry" | translate }}</span
                      >
                    </ng-container>
                  </ng-container>

                  <!-- loading -->
                  <ng-container *ngIf="loading">
                    <span
                      class="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    <span class="sr-only">Loading...</span>
                  </ng-container>
                </button>
              </div>
            </div>
          </section>
        </form>
      </div>
    </div>
  </div>
</app-page-body>

<ng-container *ngIf="isShowNumbersAggregatorList">
  <app-numbers-aggregator-list
    [model]="model"
    (closePage)="isShowNumbersAggregatorList = false"
  ></app-numbers-aggregator-list>
</ng-container>
<!--------------------------------------------------------------- help ---------------->
<ng-container *ngIf="isVisibleHelpPage">
  <app-help-page
    menuTitle="NumbersAggregator"
    (hidePage)="onHideHelpPage()"
    title="pages.numbersAggregator.title"
  >
  </app-help-page>
</ng-container>
